/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Stages/shared/contributorFieldDisplayLabels.ts.
 */

export const EMBODIED_CARBON_PER_FUNCTIONAL_UNIT_LABEL =
  "Embodied carbon per functional unit";

const EMBODIED_CARBON_PER_FUNCTIONAL_UNIT_VALUE_FIELDS = new Set([
  "embodiedCarbon_functionalUnit",
  "embodiedCarbon_functionalUnit_extraction",
]);

function isLegacyEmbodiedCarbonPerFinishedLabel(label: string): boolean {
  const normalized = label.trim().toLowerCase();
  if (!normalized.includes("embodied carbon")) return false;
  return (
    normalized.includes("declared finished material") ||
    normalized.includes("declared finished qty") ||
    normalized.includes("finished material qty") ||
    (normalized.includes("÷") && normalized.includes("finished"))
  );
}

function isEmbodiedCarbonPerFunctionalUnitValueField(field: {
  name?: string;
  type?: string;
}): boolean {
  const name = String(field.name ?? "");
  if (EMBODIED_CARBON_PER_FUNCTIONAL_UNIT_VALUE_FIELDS.has(name)) {
    return true;
  }

  const type = String(field.type ?? "").toUpperCase();
  if (type === "UNIT") return false;

  const normalized = name.toLowerCase();
  if (normalized.endsWith("_unit")) return false;

  return (
    (normalized.includes("embodiedcarbon") || normalized.includes("carbon")) &&
    normalized.includes("functional") &&
    !normalized.includes("functionalunit_unit")
  );
}

/** Normalize CMS / legacy labels for contributor form fields. */
export function resolveContributorFieldDisplayLabel(field: {
  name?: string;
  label?: string;
  type?: string;
}): string {
  const fallback = String(field.label ?? field.name ?? "This field").trim();

  if (isEmbodiedCarbonPerFunctionalUnitValueField(field)) {
    return EMBODIED_CARBON_PER_FUNCTIONAL_UNIT_LABEL;
  }

  if (isLegacyEmbodiedCarbonPerFinishedLabel(fallback)) {
    return EMBODIED_CARBON_PER_FUNCTIONAL_UNIT_LABEL;
  }

  return fallback || "This field";
}
